var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrancheWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.347,
    height: 46.183,
    viewBox: "0 0 64.347 46.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    transform: "translate(4.152 16.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M121.528,260.208a5.442,5.442,0,0,1-4.7-2.708,5.429,5.429,0,0,1-9.4,0,5.429,5.429,0,0,1-9.4,0,5.429,5.429,0,0,1-9.4,0,5.429,5.429,0,0,1-9.4,0,5.429,5.429,0,0,1-9.4,0,5.453,5.453,0,0,1-4.546,2.708v27.1h5.754V263.076H86.192v24.236h35.794V260.189C121.814,260.2,121.674,260.208,121.528,260.208ZM116.2,276.777H93.319v-13.7H116.2Z",
    transform: "translate(-65.3 -257.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M147.9,8.856v4.781a3.967,3.967,0,1,0,7.935,0v-5.2L159.783,0h-4.965Z",
    transform: "translate(-138.497)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M0,8.933v4.711a3.967,3.967,0,0,0,7.935,0V8.354L14.451,0H9.759Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M131.223,0h0L124.7,8.354Z",
    transform: "translate(-116.772)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M295.8,8.767v4.87a3.967,3.967,0,1,0,7.935,0V8.545l.877-5.639L305.063,0h-5.156Z",
    transform: "translate(-276.994)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M299.907,0,295.8,8.767Z",
    transform: "translate(-276.994)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M444.954,0,443.6,8.666v4.978a3.967,3.967,0,0,0,7.935,0V8.666L450.18,0Z",
    transform: "translate(-415.397)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M570.6,0l1.335,8.551v5.093a3.967,3.967,0,0,0,7.935,0V8.774L575.756,0Z",
    transform: "translate(-534.323)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M570.6,0l1.335,8.551Z",
    transform: "translate(-534.323)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M677.3,0l3.955,8.443v5.2a3.967,3.967,0,0,0,7.935,0V8.863L682.265,0Z",
    transform: "translate(-634.239)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M795.284,17.6a3.972,3.972,0,0,0,3.967-3.967V8.926L789.492,0H784.8l6.523,8.354v5.29A3.957,3.957,0,0,0,795.284,17.6Z",
    transform: "translate(-734.904)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M784.8,0l6.517,8.354Z",
    transform: "translate(-734.904)",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrancheWhite);
export default __webpack_public_path__ + "static/media/brancheWhite.50bbed94799441785c55411eb89046c0.svg";
export { ForwardRef as ReactComponent };